// import createTypes from 'desktop/utils/createTypes';

export default {
  EVENT_CURRENT_PROGRAM_CHANGED: 'APP.EVENT_CURRENT_PROGRAM_CHANGED', //
  EVENT_ACTIVE_PROGRAM_CHANGED: 'APP.EVENT_ACTIVE_PROGRAM_CHANGED', //
  EVENT_CURRENT_PROGRAM_LIST_UPDATED: 'APP.EVENT_CURRENT_PROGRAM_LIST_UPDATED', //
  EVENT_CHANNELS_READY: 'APP.EVENT_CHANNELS_READY', //
  EVENT_PROGRAMS_READY: 'APP.EVENT_PROGRAMS_READY', //
  EVENT_CHANNEL_SWITCH: 'APP.EVENT_CHANNEL_SWITCH', //
  EVENT_SWITCH_PROGRAM: 'APP.EVENT_SWITCH_PROGRAM', //
  EVENT_CURRENT_CHANNEL_CHANGED: 'APP.EVENT_CURRENT_CHANNEL_CHANGED', //
  EVENT_PLAYING_PROGRAM_CHANGED: 'APP.EVENT_PLAYING_PROGRAM_CHANGED', //
  EVENT_FAVORITE_TOGGLED: 'APP.EVENT_FAVORITE_TOGGLED',
  EVENT_SUBSCRIPTION_INFO_LOADED: 'APP.EVENT_SUBSCRIPTION_INFO_LOADED',
  SET_CURRENT_CHANNEL_ABSOLUTE_ID: 'APP.SET_CURRENT_CHANNEL_ABSOLUTE_ID', //
  ALL_CHANNELS_BUTTON_INFO: 'APP.ALL_CHANNELS_BUTTON_INFO',
};
